export default "__VITE_ASSET__Cf1W_E3l__"